export interface SEOConfig {
  title: string;
  description: string;
  keywords: string;
  ogImage?: string;
  ogType?: string;
  noindex?: boolean;
}

export const seoConfigs: Record<string, SEOConfig> = {
  home: {
    title: 'Oreog - Multi-Model AI Chat Platform | ChatGPT, Claude, Gemini & More',
    description: 'Experience the power of multiple AI models in one platform. Chat with ChatGPT, Claude, Gemini, DeepSeek, LLaMA, and Qwen. Use AI agents, web search, and deep research capabilities.',
    keywords: 'AI chat, ChatGPT, Claude AI, Gemini AI, DeepSeek, LLaMA, Qwen, multi-model AI, AI assistant, conversational AI, artificial intelligence',
    ogImage: '/image.png',
    ogType: 'website',
  },
  
  discover: {
    title: 'Discover AI - Trending Topics & AI Insights | Oreog',
    description: 'Explore trending AI topics, deep dives, focus areas, and daily AI insights. Stay updated with the latest in artificial intelligence and technology.',
    keywords: 'AI trends, AI news, AI insights, technology trends, AI topics, deep research, AI discovery, artificial intelligence news',
    ogImage: '/image.png',
    ogType: 'website',
  },
  
  chitraAI: {
    title: 'Chitra AI - AI Image Generation & Editing | Oreog',
    description: 'Generate stunning AI images and edit them with natural language. Powered by advanced AI models including Stable Diffusion and Reve AI. Create, edit, and download high-quality images.',
    keywords: 'AI image generation, AI art, image editing, Stable Diffusion, AI artwork, text to image, AI image editor, Chitra AI, generative AI',
    ogImage: '/image.png',
    ogType: 'website',
  },
  
  aawaz: {
    title: 'Aawaz - AI Voice Assistant | Oreog',
    description: 'Talk to AI with voice commands. Advanced voice recognition and natural language processing for seamless voice interactions with AI models.',
    keywords: 'AI voice assistant, voice AI, speech recognition, voice commands, AI conversation, voice chat, natural language processing',
    ogImage: '/image.png',
    ogType: 'website',
  },
  
  aiNews: {
    title: 'AI News - Latest Artificial Intelligence Updates | Oreog',
    description: 'Stay updated with the latest AI news, breakthroughs, and developments. Curated AI articles and insights from around the world.',
    keywords: 'AI news, artificial intelligence news, AI updates, machine learning news, AI breakthroughs, technology news, AI developments',
    ogImage: '/image.png',
    ogType: 'website',
  },
  
  settings: {
    title: 'Settings - Customize Your AI Experience | Oreog',
    description: 'Personalize your Oreog experience. Manage your account, preferences, API keys, and customize AI model settings.',
    keywords: 'AI settings, account settings, preferences, customization, API keys, AI configuration',
    ogImage: '/image.png',
    ogType: 'website',
  },
  
  terms: {
    title: 'Terms of Service | Oreog',
    description: 'Read the terms of service for using Oreog AI platform. Understand your rights and responsibilities.',
    keywords: 'terms of service, terms and conditions, user agreement, legal terms, Oreog terms',
    ogImage: '/image.png',
    ogType: 'website',
  },
  
  privacy: {
    title: 'Privacy Policy | Oreog',
    description: 'Learn how Oreog protects your privacy and handles your data. Our commitment to user privacy and data security.',
    keywords: 'privacy policy, data protection, privacy, data security, user privacy, GDPR compliance',
    ogImage: '/image.png',
    ogType: 'website',
  },
  
  sudoku: {
    title: 'Sudoku Game - Play Online | Oreog',
    description: 'Play Sudoku online with multiple difficulty levels. Challenge yourself with this classic puzzle game.',
    keywords: 'sudoku, online sudoku, puzzle game, brain game, sudoku online, logic puzzle',
    ogImage: '/image.png',
    ogType: 'game',
  },
};

export const getPageSEO = (pathname: string): SEOConfig => {
  const routeMap: Record<string, string> = {
    '/': 'home',
    '/discover': 'discover',
    '/chitra-ai': 'chitraAI',
    '/aawaz': 'aawaz',
    '/ai-news': 'aiNews',
    '/settings': 'settings',
    '/terms': 'terms',
    '/privacy': 'privacy',
    '/sudoku': 'sudoku',
  };

  const configKey = routeMap[pathname] || 'home';
  return seoConfigs[configKey];
};
